import { Breadcrumbs, Link, Typography } from "@mui/material";
import { FontHeader, FontHeaderPrevious } from "@/styles/globalstyles";
import menu from "@/layouts/menu";
import { useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";

interface Page {
    key: string;
    path?: string;
}

interface BreadcrumbProps {
    current?: string;
    previous?: Page[];
}

export const Breadcrumb = ({ current, previous }: BreadcrumbProps) => {
    const currentPage = useMemo<string>(() => {
        if (!current) return "";
        const page = menu.find((item) => item.key === current);
        return page ? page.name : current;
    }, [current]);

    const previousPages = useMemo<Page[]>(() => {
        if (!previous || previous.length === 0) return [];
        return previous.map((prev) => {
            const page = menu.find((item) => item.key === prev.key);
            return {
                key: page ? page.name : prev.key,
                path: page ? page.path : prev.path
            }
        });
    }, [previous]);


    return (
        <Breadcrumbs sx={{ ...FontHeaderPrevious }}>
            {previousPages.map((page, index) => (
                <Link
                    key={index}
                    component={RouterLink}
                    to={page.path ?? ""}
                    underline="hover"
                    sx={{ cursor: page.path ? "pointer" : "default" }}
                    color="inherit"
                >
                    {page.key}
                </Link>
            ))}
            <Typography sx={FontHeader}>{currentPage}</Typography>
        </Breadcrumbs>
    );
}

export default Breadcrumb;